/**
 * Copyright 2017 Control4 Corporation. All rights reserved.
 * Control4 Confidential and Proprietary Information.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { StoreModule } from '@ngrx/store';
import { DragulaModule } from 'ng2-dragula/ng2-dragula';

import { UIModule } from '@c4/ui';
import { CoreModule } from '@c4/core';
import { AuthModule } from '@c4/auth';

import { ProgrammingRoutingModule } from './programming.routes';
import { ProgrammingCommonModule } from './common/common.module';
import { QuickstartsProgrammingModule } from './quickstarts/quickstarts.module';
import { AdvancedProgrammingModule } from './advanced/advanced.module';

import { ProgrammingComponent } from './programming.component';

require('./common/assets/styles/common.less');

export const MODULE_ROOT: Function = ProgrammingComponent;

@NgModule({
  imports: [
    // --- angular
    BrowserModule,
    FormsModule,
    HttpModule,
    CommonModule,
    // --- router
    RouterModule,
    // --- @ngrx
    StoreModule,
    // --- third-parties
    DragulaModule,
    // --- framework
    CoreModule,
    AuthModule,
    UIModule,
    // --- local
    ProgrammingCommonModule,
    AdvancedProgrammingModule,
    QuickstartsProgrammingModule,
    ProgrammingRoutingModule,
  ],
  declarations: [
    ProgrammingComponent
  ],
  providers: [
  ],
  exports: []
})
export class ProgrammingModule { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/programming.module.ts